import { Row } from 'antd';
import React from 'react';

import { ToolCard } from '@/components/ToolCard';
import { IntegratedErgonomicToolDTO } from '@/components/ui/Inputs/types/response/customReport';
import { ErgonomicToolMapper } from '@/components/ui/Inputs/types/response/ergonomicTool';

interface ToolCardsProps {
	integratedTools: IntegratedErgonomicToolDTO[];
	ergonomicTool: ErgonomicToolMapper;
	populate: boolean;
	fileId: string;
}

export function ToolCards({
	integratedTools,
	ergonomicTool,
	populate,
	fileId
}: Readonly<ToolCardsProps>): JSX.Element | null {
	if (populate) {
		return <></>;
	}

	return (
		<>
			{integratedTools?.map((integratedTool) => (
				<Row key={integratedTool.id} align="bottom" style={{ marginTop: '1rem' }}>
					<ToolCard
						key={integratedTool.id}
						isActive={ergonomicTool[integratedTool.name]?.isActive}
						reportSelected={integratedTool.description}
						title={integratedTool.title}
						fileId={fileId}
					/>
				</Row>
			))}
		</>
	);
}
